<div class="region-dashboard">
  <div class="tenant-filter">
    <form [formGroup]="form">
      <div class="filter-control-group">
        <label class="label" for="region">Region</label>
        <wr-region-select
          [fixedTenantId]="currentTenantId()"
          (regionSelected)="onRegionSelected($event)">
        </wr-region-select>
      </div>
    </form>
  </div>

  <div class="region-dashboard-grid" *ngIf="selectedRegion; else noRegionSelected">
    <wr-region-dashboard-info [region]="selectedRegion"></wr-region-dashboard-info>
    <wr-region-dashboard-teamcards [region]="selectedRegion"></wr-region-dashboard-teamcards>
    <wr-region-dashboard-map [region]="selectedRegion"></wr-region-dashboard-map>
  </div>

  <ng-template #noRegionSelected>
    <div class="empty-state-message">
      Bitte wählen Sie einen Bereich aus.
    </div>
  </ng-template>
</div>
